export default {
  display: 'flex',
  flexDirection: 'column',
  gap: [null, 3, null, null, 5],
  bg: 'contentBg',
  borderColor: 'gray300',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderRadius: '12px',
  px: [null, 4, null, null, 7],
  py: [null, 5, null, null, 7],
};
